import { DocumentReference, getDoc } from 'firebase/firestore'
import { tokenRef } from 'firebaseAdapter/refs'

const getToken = async ({ ref }: { ref: DocumentReference }) => {
  const snapshot = await getDoc(tokenRef(ref))
  return snapshot.data()
}

export default getToken
